import * as Yup from 'yup';

import { phoneNumberIsValid } from '../../../../modules/formatting';

export default Yup.object().shape({
  user: Yup.object().shape({
    firstName: Yup.string().required('Please enter your first name.'),
    lastName: Yup.string().required('Please enter your last name.'),
    phone: Yup.string()
      .test('phone-validation', 'Phone number is not valid.', value =>
        phoneNumberIsValid(value)
      )
      .required('Please enter your phone number.'),
    email: Yup.string()
      .email('Please enter a valid email address.')
      .required('Please enter your email address.'),
    password: Yup.string()
      .min(8, 'Password is too short - 8 characters minimum.')
      .required('Please enter a password.'),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref('password')], "Passwords don't match")
      .required('Please confirm your password.'),
    terms: Yup.bool()
      .oneOf([true], 'You must accept the terms and conditions.')
      .required(),
  }),
});
